import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    driverAllowanceServiceV1ListDriverAllowances: build.query<
      DriverAllowanceServiceV1ListDriverAllowancesApiResponse,
      DriverAllowanceServiceV1ListDriverAllowancesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          vehicle_type_name: queryArg.vehicleTypeName,
          vehicle_model_name: queryArg.vehicleModelName,
          distance_type_name: queryArg.distanceTypeName,
          trip_type_name: queryArg.tripTypeName,
          driver_basic_rate: queryArg.driverBasicRate,
          driver_insentif_rate: queryArg.driverInsentifRate,
          waiting_time_rate_name: queryArg.waitingTimeRateName,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    driverAllowanceServiceV1BatchCreateDriverAllowance: build.mutation<
      DriverAllowanceServiceV1BatchCreateDriverAllowanceApiResponse,
      DriverAllowanceServiceV1BatchCreateDriverAllowanceApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances`,
        method: "POST",
        body: queryArg.driverAllowanceV1BatchCreateDriverAllowanceReq,
      }),
    }),
    driverAllowanceServiceV1ActivateDriverAllowances: build.mutation<
      DriverAllowanceServiceV1ActivateDriverAllowancesApiResponse,
      DriverAllowanceServiceV1ActivateDriverAllowancesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances/activate`,
        method: "PATCH",
        body: queryArg.driverAllowanceV1DriverAllowanceBulkStatusChangeReq,
      }),
    }),
    driverAllowanceServiceV1DeactivateDriverAllowances: build.mutation<
      DriverAllowanceServiceV1DeactivateDriverAllowancesApiResponse,
      DriverAllowanceServiceV1DeactivateDriverAllowancesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances/deactivate`,
        method: "PATCH",
        body: queryArg.driverAllowanceV1DriverAllowanceBulkStatusChangeReq,
      }),
    }),
    driverAllowanceServiceV1GetDriverAllowanceDistanceTypes: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceDistanceTypesApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceDistanceTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/driver-allowances/distance-types` }),
    }),
    driverAllowanceServiceV1GetDriverAllowanceTripTypes: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceTripTypesApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceTripTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/driver-allowances/trip-types` }),
    }),
    driverAllowanceServiceV1GetDriverAllowanceVehicleModels: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceVehicleModelsApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances/vehicle-models`,
        params: {
          vehicle_type_id: queryArg.vehicleTypeId,
        },
      }),
    }),
    driverAllowanceServiceV1GetDriverAllowanceVehicleTypes: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceVehicleTypesApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceVehicleTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/driver-allowances/vehicle-types` }),
    }),
    driverAllowanceServiceV1GetDriverAllowanceWaitingTimeRates: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceWaitingTimeRatesApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceWaitingTimeRatesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/driver-allowances/waiting-time-rates` }),
    }),
    driverAllowanceServiceV1GetDriverAllowance: build.query<
      DriverAllowanceServiceV1GetDriverAllowanceApiResponse,
      DriverAllowanceServiceV1GetDriverAllowanceApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/driver-allowances/${queryArg.id}` }),
    }),
    driverAllowanceServiceV1UpdateDriverAllowance: build.mutation<
      DriverAllowanceServiceV1UpdateDriverAllowanceApiResponse,
      DriverAllowanceServiceV1UpdateDriverAllowanceApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/driver-allowances/${queryArg.id}`,
        method: "PUT",
        body: queryArg.driverAllowanceServiceV1UpdateDriverAllowanceBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as driverAllowanceApi };
export type DriverAllowanceServiceV1ListDriverAllowancesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1ListDriverAllowancesRes;
export type DriverAllowanceServiceV1ListDriverAllowancesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  vehicleTypeName?: string;
  vehicleModelName?: string;
  distanceTypeName?: string;
  tripTypeName?: string;
  driverBasicRate?: number;
  driverInsentifRate?: number;
  waitingTimeRateName?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type DriverAllowanceServiceV1BatchCreateDriverAllowanceApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1DriverAllowanceMessageRes;
export type DriverAllowanceServiceV1BatchCreateDriverAllowanceApiArg = {
  driverAllowanceV1BatchCreateDriverAllowanceReq: DriverAllowanceV1BatchCreateDriverAllowanceReq;
};
export type DriverAllowanceServiceV1ActivateDriverAllowancesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1DriverAllowanceBulkStatusChangeRes;
export type DriverAllowanceServiceV1ActivateDriverAllowancesApiArg = {
  driverAllowanceV1DriverAllowanceBulkStatusChangeReq: DriverAllowanceV1DriverAllowanceBulkStatusChangeReq;
};
export type DriverAllowanceServiceV1DeactivateDriverAllowancesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1DriverAllowanceBulkStatusChangeRes;
export type DriverAllowanceServiceV1DeactivateDriverAllowancesApiArg = {
  driverAllowanceV1DriverAllowanceBulkStatusChangeReq: DriverAllowanceV1DriverAllowanceBulkStatusChangeReq;
};
export type DriverAllowanceServiceV1GetDriverAllowanceDistanceTypesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1GetDriverAllowanceDistanceTypesRes;
export type DriverAllowanceServiceV1GetDriverAllowanceDistanceTypesApiArg =
  void;
export type DriverAllowanceServiceV1GetDriverAllowanceTripTypesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1GetDriverAllowanceTripTypesRes;
export type DriverAllowanceServiceV1GetDriverAllowanceTripTypesApiArg = void;
export type DriverAllowanceServiceV1GetDriverAllowanceVehicleModelsApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1GetDriverAllowanceVehicleModelsRes;
export type DriverAllowanceServiceV1GetDriverAllowanceVehicleModelsApiArg = {
  vehicleTypeId?: string;
};
export type DriverAllowanceServiceV1GetDriverAllowanceVehicleTypesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1GetDriverAllowanceVehicleTypesRes;
export type DriverAllowanceServiceV1GetDriverAllowanceVehicleTypesApiArg = void;
export type DriverAllowanceServiceV1GetDriverAllowanceWaitingTimeRatesApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1GetDriverAllowanceWaitingTimeRatesRes;
export type DriverAllowanceServiceV1GetDriverAllowanceWaitingTimeRatesApiArg =
  void;
export type DriverAllowanceServiceV1GetDriverAllowanceApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1DriverAllowanceDetailRes;
export type DriverAllowanceServiceV1GetDriverAllowanceApiArg = {
  id: string;
};
export type DriverAllowanceServiceV1UpdateDriverAllowanceApiResponse =
  /** status 200 A successful response. */ DriverAllowanceV1DriverAllowanceMessageRes;
export type DriverAllowanceServiceV1UpdateDriverAllowanceApiArg = {
  id: string;
  driverAllowanceServiceV1UpdateDriverAllowanceBody: DriverAllowanceServiceV1UpdateDriverAllowanceBody;
};
export type DriverAllowanceV1DriverAllowanceRefItem = {
  id?: string;
  name?: string;
};
export type DriverAllowanceV1DriverAllowanceRes = {
  id?: string;
  vehicle_type?: DriverAllowanceV1DriverAllowanceRefItem;
  vehicle_model?: DriverAllowanceV1DriverAllowanceRefItem;
  distance_type?: DriverAllowanceV1DriverAllowanceRefItem;
  trip_type?: DriverAllowanceV1DriverAllowanceRefItem;
  driver_basic_rate?: number;
  driver_insentif_rate?: number;
  waiting_time_rate?: DriverAllowanceV1DriverAllowanceRefItem;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type DriverAllowanceV1DriverAllowancePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type DriverAllowanceV1ListDriverAllowancesRes = {
  driver_allowances?: DriverAllowanceV1DriverAllowanceRes[];
  metadata?: DriverAllowanceV1DriverAllowancePaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type DriverAllowanceV1DriverAllowanceMessageRes = {
  message?: string;
};
export type DriverAllowanceV1CreateDriverAllowanceItem = {
  vehicle_type_id: string;
  vehicle_model_id: string;
  distance_type_id: string;
  trip_type_id: string;
  driver_basic_rate: number;
  driver_insentif_rate: number;
  waiting_time_rate_id: string;
  status: string;
};
export type DriverAllowanceV1BatchCreateDriverAllowanceReq = {
  driver_allowances: DriverAllowanceV1CreateDriverAllowanceItem[];
};
export type DriverAllowanceV1DriverAllowanceBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type DriverAllowanceV1DriverAllowanceBulkStatusChangeReq = {
  ids: string[];
};
export type DriverAllowanceV1GetDriverAllowanceDistanceTypesRes = {
  distance_types?: DriverAllowanceV1DriverAllowanceRefItem[];
};
export type DriverAllowanceV1GetDriverAllowanceTripTypesRes = {
  trip_types?: DriverAllowanceV1DriverAllowanceRefItem[];
};
export type DriverAllowanceV1GetDriverAllowanceVehicleModelsRes = {
  vehicle_models?: DriverAllowanceV1DriverAllowanceRefItem[];
};
export type DriverAllowanceV1GetDriverAllowanceVehicleTypesRes = {
  vehicle_types?: DriverAllowanceV1DriverAllowanceRefItem[];
};
export type DriverAllowanceV1GetDriverAllowanceWaitingTimeRatesRes = {
  waiting_time_rates?: DriverAllowanceV1DriverAllowanceRefItem[];
};
export type DriverAllowanceV1DriverAllowanceDetailRes = {
  id?: string;
  vehicle_type?: DriverAllowanceV1DriverAllowanceRefItem;
  vehicle_model?: DriverAllowanceV1DriverAllowanceRefItem;
  distance_type?: DriverAllowanceV1DriverAllowanceRefItem;
  trip_type?: DriverAllowanceV1DriverAllowanceRefItem;
  driver_basic_rate?: number;
  driver_insentif_rate?: number;
  waiting_time_rate?: DriverAllowanceV1DriverAllowanceRefItem;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type DriverAllowanceServiceV1UpdateDriverAllowanceBody = {
  vehicle_type_id: string;
  vehicle_model_id: string;
  distance_type_id: string;
  trip_type_id: string;
  driver_basic_rate: number;
  driver_insentif_rate: number;
  waiting_time_rate_id: string;
};
export const {
  useDriverAllowanceServiceV1ListDriverAllowancesQuery,
  useDriverAllowanceServiceV1BatchCreateDriverAllowanceMutation,
  useDriverAllowanceServiceV1ActivateDriverAllowancesMutation,
  useDriverAllowanceServiceV1DeactivateDriverAllowancesMutation,
  useDriverAllowanceServiceV1GetDriverAllowanceDistanceTypesQuery,
  useDriverAllowanceServiceV1GetDriverAllowanceTripTypesQuery,
  useDriverAllowanceServiceV1GetDriverAllowanceVehicleModelsQuery,
  useDriverAllowanceServiceV1GetDriverAllowanceVehicleTypesQuery,
  useDriverAllowanceServiceV1GetDriverAllowanceWaitingTimeRatesQuery,
  useDriverAllowanceServiceV1GetDriverAllowanceQuery,
  useDriverAllowanceServiceV1UpdateDriverAllowanceMutation,
} = injectedRtkApi;
